import SendNote from './send_note'
import { reduxForm, getValues } from 'redux-form'
import formUtils from 'lib/form_utils'
import { length } from 'lib/validators'
import { getI18n } from 'client/i18n'
import { NOTE_LENGTH } from 'shared/lengths'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n('components/send_glimpse/send_note')

const mapStateToProps = (state, props) => {
  const { location: { pathname = '' } = {} } = props
  const amount = getValues(state.form.send).amount
  const anonymous = getValues(state.form.send).anonymous
  const campaign = getCampaignSelector(state, props)
  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    isGuest: pathname.includes('guest'),
    currency: campaign.currency,
    amount: amount,
    anonymous: anonymous,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default reduxForm(
  {
    form: 'send',
    fields: ['note'],
    validate: length('note', NOTE_LENGTH, i18n('note_too_long')),
    destroyOnUnmount: false,
    touchOnChange: true,
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(SendNote))
